<template>
<div class="wrap">
  <!-- <Header activeIndex=""/> -->
  <div class="forget">
    <div class="title">重置密码</div>
    <div class="box">
      <div class="int"><el-input v-model="form.username" placeholder="请输入邮箱"></el-input></div>
      <div class="code">
        <div class="left"><el-input v-model="form.code" placeholder="请输入验证码"></el-input></div>
        <div class="right"><el-button class="buttint">验证码</el-button></div>
      </div>
      <div class="int"><el-input v-model="form.password" placeholder="请输入新密码"></el-input></div>
      <div class="int"><el-input v-model="form.surePassword" placeholder="请输入确认密码"></el-input></div>
      <div class="int">
        <el-button class="buttint">重置</el-button>
      </div>
    </div>
  </div>
  <Footer :show="false"/>
</div>
</template>

<script>
// import Footer from "@/components/Footer/index";
// import Header from "@/components/Header/Header";


export default {
  name: "forget",
  // components: { Footer,Header },
  data(){
    return{
      form:{
        username:"",
        code:"",
        password:"",
        surePassword:""
      }
    }
  },
}
</script>

<style scoped lang="scss">
.wrap {
  padding-top: 100px;
}
.buttint{
  width: 80%;
  background-color: #25877d;
  color: #ffffff;
}
.forget{
  width: 100%;
  .title{
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding: 30px 0;
  }
  .box{
    width: 30%;
    margin: 0 auto;
    .int{
      padding: 5px 0;
    }
    .code{
      width: 100%;
      display: flex;
      .left{
        width: 70%;
      }
      .right{
        width: 30%;
        display: flex;
        justify-content: flex-end;
        .buttint{
          width: 80%;
          background-color: #25877d;
          color: #ffffff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Login/Forget.vue